import './track-title.sass';

import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';

export default function TrackTitle(props) {
  if (!props.track
    || !props.track.vehicle
    || !props.track.name
    || !props.track.origin
    || !props.track.destination
    || !props.track.startedAtFormatted
  ) {
    return null
  }

  return (
    <div className='tracks-tree-track-title' data-track-id={ props.track.id }>
      <div>
        { props.track.recorderName }.&nbsp;
        <Translate value='tracksTree.trackTitle.organization' />
        &nbsp;-&nbsp;
        { props.track.organization },&nbsp;
        <Translate value='tracksTree.trackTitle.startedAt' />
        &nbsp;-&nbsp;
        { props.track.startedAtFormatted }
      </div>
      <div>
        <Translate value='tracksTree.trackTitle.vehicle' />
        &nbsp;-&nbsp;
        { props.track.vehicle },&nbsp;
        <Translate value='tracksTree.trackTitle.name' />
        &nbsp;-&nbsp;
        { props.track.name },&nbsp;
        <Translate value='tracksTree.trackTitle.origin' />
        &nbsp;-&nbsp;
        { props.track.origin },&nbsp;
        <Translate value='tracksTree.trackTitle.destination' />
        &nbsp;-&nbsp;
        { props.track.destination }
      </div>
    </div>
  );
}
